<div class="simple-page-container">

  <div class="container">

    <app-section-heading [label]="'Műszaki tartalom'"></app-section-heading>


    <div class="editor-container">
      <app-html-editor-wrapper [showButtons]="isLoggedIn" *ngIf="content" (contentSaved)="onContentSaved($event)"
                               [value]="content"></app-html-editor-wrapper>
    </div>
  </div>
</div>
